













































import { Component, Prop, Watch, Vue } from "vue-property-decorator";
import axios from "@/api/AuthAPI/auth-request-api";
import { splitString } from "@/services/strings";

import Progress from "@/components/app/images/progress.vue";
import LanguagesBtns from "@/components/app/shared/btn&dd/languages-btns.vue";

import { size, type } from "@/config/files.config.json";
import { pics } from "@/config/host.config";
import { preferred_language } from "@/config/languags.config.json";
import type { ILocale } from "@/@types/locale";
import type { LanguageCode } from "@/@types/_shared/locale";

@Component({
  components: {
    "progress-component": Progress,
    LanguagesBtns,
  },
})
class ConsentsPosterUpload extends Vue {
  @Prop({ type: Object, default: () => ({}) }) value!: ILocale;
  @Prop({ type: String, default: "" }) code!: string;

  locale: LanguageCode = preferred_language as LanguageCode;

  progress = {
    variant: "primary",
    value: 0,
  };

  $refs!: {
    file: HTMLInputElement;
  };

  get poster(): string {
    return this.value[this.locale] || "";
  }

  get pdfName(): string {
    return this.poster.split("/").pop() || this.poster;
  }

  get fileUrl(): string {
    return this.poster && this.code
      ? this.$getWebImage(this.poster, `consents/${this.code}/${this.locale}`)
      : "";
  }

  handleFileUpload(): void {
    const file = this.$refs.file.files ? this.$refs.file.files[0] : null;
    if (!file) return;
    if (!this.getFileFormat(file.type)) {
      this.$notify({
        group: "global",
        text: String(this.$i18n.t("error.empty400")),
        type: "warn",
      });
      return;
    }
    if (file.size > size.pdf) {
      this.$notify({
        group: "global",
        text: String(this.$i18n.t("error.empty400")),
        type: "warn",
      });
      return;
    }
    this.uploadPoster(file);
  }

  getFileFormat(string: string | undefined): boolean {
    if (!string) return false;
    const splitArr = splitString(string, "/");
    return type.pdf.includes(splitArr[splitArr.length - 1]);
  }

  async uploadPoster(file: File): Promise<void> {
    try {
      this.progress.value = 1;
      const formData = new FormData();
      formData.append("poster", file);

      const params = {
        path: `consents/${this.code}`,
        lang: this.locale,
      };
      const config = {
        onDownloadProgress: (event: ProgressEvent) => {
          this.progress.value = Math.round((event.loaded * 100) / event.total);
        },
        headers: {
          "Content-Type": "multipart/form-data",
        },
        params,
      };

      const res = await axios.post(pics.uploadPdf, formData, config);
      if (res.status === 200) {
        const poster = { ...this.value };
        poster[this.locale] = res.data;
        this.$emit("input", poster);
        this.progress.value = 0;
        this.$notify({
          group: "global",
          text: String(this.$i18n.t("error.200")),
        });
      }
    } catch (error) {
      console.error(error);
      this.progress.variant = "danger";
      this.$notify({
        group: "global",
        text: String(this.$i18n.t("error.empty400")),
        type: "warn",
      });
    }
  }

  @Watch("locale")
  resetProgress(): void {
    this.progress = { variant: "primary", value: 0 };
  }
}
export default ConsentsPosterUpload;
